import {
  SET_LATEST_PAYROLLS_LIST,
  SET_DATES_WITH_PAYROLLS
} from '../constants/actionTypes/payroll';

/* Api */
import {
  getLatestPayrollList,
  getDatesWithPayrolls
} from '../utils/apiPayroll';

/* Utils */
import { getMonth } from '../utils/dates';

export const setLatestPayrollsList = dispatch =>
  new Promise(resolved => {
    getLatestPayrollList()
      .then(response => {
        const dataUpdated = response.map(item => {
          const date = new Date(item.payslipDate);
          const month = getMonth(date);
          const year = date.getFullYear();
          const typeEnum = {
            PAYMENT: '',
            EXTRA_PAYMENT: 'Paga extra',
            BACK_PAYMENT: 'Atrasos acumulados'
          };

          return {
            month,
            year,
            type: typeEnum[item.payslipType],
            rawData: item
          };
        });

        dispatch({
          type: SET_LATEST_PAYROLLS_LIST,
          latestPayrollList: dataUpdated
        });

        resolved(dataUpdated);
      })
      .catch(error => {
        throw error;
      });
  });

export const setDatesWithPayrolls = dispatch =>
  new Promise(resolved => {
    getDatesWithPayrolls()
      .then(response => {
        const yearsPlusMonths = Object.entries(response).sort(
          (firstItem, secondItem) => (firstItem[0] < secondItem[0] ? 1 : -1)
        );

        dispatch({
          type: SET_DATES_WITH_PAYROLLS,
          datesWithPayrolls: yearsPlusMonths
        });

        resolved(yearsPlusMonths);
      })
      .catch(error => {
        throw error;
      });
  });

export const setCompletePayrollData = dispatch => {
  const allData = [
    setLatestPayrollsList(dispatch),
    setDatesWithPayrolls(dispatch)
  ];

  return Promise.all(allData)
    .then(data => data)
    .catch(error => {
      throw error;
    });
};
